import { useIntl } from '@edx/frontend-platform/i18n';
import StaticPageLayout from './StaticPageLayout';
import { getPrivacyPageContent } from './content';

const PrivacyPage = () => {
  const intl = useIntl();

  return <StaticPageLayout {...getPrivacyPageContent(intl)} />;
};

export default PrivacyPage;
